'use strict';
/* jshint ignore:start */
var util = require('site/util'),
	_ = require('lodash');

var cart = {
	removeFromBag: function (e) {
		var target = $(e.target);
		var pid = $(e.target).closest('tr').data('pid');
		var obj = {
			'event': 'removeFromBag',
			'button_ID': e.currentTarget.id ? e.currentTarget.id : e.currentTarget.name
		};
		$.extend(obj, getProductsInCart(pid));
		dataLayer.push(obj);
	},

	clearBag: function (e) {
		var obj = {
			'event': 'clearBag',
			'button_ID': e.currentTarget.id ? e.currentTarget.id : e.currentTarget.name
		};
		dataLayer.push(obj);
	},

	updateProductInBag: function (e) {
		var obj = {
			'event': 'update product in bag',
			'button_ID': e.currentTarget.id ? e.currentTarget.id : e.currentTarget.name
		};
		var basketDataInput = $('input[name=basketData]');
		var pid = $(e.target).closest('tr').data('pid');
		if (basketDataInput.length > 0) {
			var basketData = JSON.parse(basketDataInput.val());
			var products = basketData.product;
			var hampers = basketData.hamper;
			var product = _.find(products, function (item) {
				return item.product_ID == pid;
			});
			var hamper = _.find(hampers, function (item) {
				return item.hamper_ID == pid;
			});

			if (product) {
				obj['product_brand'] = product.product_brand;
				obj['product_category'] = product.product_category;
				obj['product_delivery'] = product.product_delivery;
				obj['product_delivery_cost'] = product.product_delivery_cost;
				obj['product_discount'] = product.product_discount;
				obj['product_hierarchy'] = product.product_hierarchy;
				obj['product_ID'] = product.product_ID;
				obj['product_name'] = product.product_name;
				obj['product_price'] = product.product_price;
				obj['product_price_old'] = product.product_price_old;
				obj['product_quantity'] = product.product_quantity;
				obj['product_SKU'] = product.product_SKU;
				obj['product_stock_status'] = product.product_stock_status;
				obj['product_variant'] = product.product_variant;
				obj['product_vat'] = product.product_vat;
				obj['product_set_capacity'] = '';
				obj['product_set_items_added'] = '';
				obj['product_set_name'] =  '';
				obj['product_set_price'] = '';
				obj['product_set_size'] = '';
				obj['product_set_SKU'] = '';
				obj['product_set_type'] = '';
				obj['re_wheat_allergy'] = product.re_wheat_allergy;

			} else if (hamper) {
				obj['product_brand'] = hamper.hamper_brand;
				obj['product_category'] = hamper.hamper_category;
				obj['product_delivery'] = hamper.hamper_delivery;
				obj['product_delivery_cost'] = hamper.hamper_delivery_cost;
				obj['product_discount'] = hamper.hamper_discount;
				obj['product_hierarchy'] = hamper.hamper_hierarchy;
				obj['product_ID'] = hamper.hamper_ID;
				obj['product_name'] = hamper.hamper_name;
				obj['product_price'] = hamper.hamper_price;
				obj['product_price_old'] = hamper.hamper_price_old;
				obj['product_quantity'] = hamper.hamper_quantity;
				obj['product_SKU'] = hamper.hamper_SKU;
				obj['product_stock_status'] = hamper.hamper_stock_status;
				obj['product_variant'] = hamper.hamper_variant;
				obj['product_vat'] = hamper.hamper_vat;
				obj['product_set_capacity'] = hamper.hamper_set_capacity;
				obj['product_set_items_added'] = hamper.hamper_set_items_added;
				obj['product_set_name'] =  hamper.hamper_set_name;
				obj['product_set_price'] = hamper.hamper_set_price;
				obj['product_set_size'] = hamper.hamper_set_size;
				obj['product_set_SKU'] = hamper.hamper_set_SKU;
				obj['product_set_type'] = hamper.hamper_set_type;
				obj['re_wheat_allergy'] = hamper.re_wheat_allergy;
			}
		}
		dataLayer.push(obj);
	},

	promoCodeClickEvent: function () {
		var obj = {
			'event': 'applyVoucherCode',
			'event_step': 'Click'
		};
		dataLayer.push(obj);
	},

	promoCodeAttemptEvent: function () {
		var obj = {
			'event': 'applyVoucherCode',
			'event_step': 'Attempt'
		};
		dataLayer.push(obj);
	},

	promoCodeFailureEvent: function () {
		var obj = {
			'event': 'applyVoucherCode',
			'event_step': 'Failure',
			'error_message': Resources.COUPON_CODE_MISSING
		};
		dataLayer.push(obj);
	},
	addConfiguratorAddToBagEvents: function () {
		var configuratorAddToBagEvents;
		if ($('input[name=configuratorAddToBagEvents]').length > 0) {
			configuratorAddToBagEvents = JSON.parse($('input[name=configuratorAddToBagEvents]').val());
		}

		if (!configuratorAddToBagEvents) {
			return;
		}

		var cartObject = JSON.parse($('input[name=cartData]').val());
		for (var i = 0; i < configuratorAddToBagEvents.length; i++) {
			var productObject = configuratorAddToBagEvents[i];
			var obj = {
				'event': 'addToBag',
				'button_ID': 'add-to-cart',
				'product': productObject,
				'voucher_ID': cartObject.voucher_ID,
				'voucher_total': cartObject.voucher_total,
				're_product_image': '',// product image
				're_product_url': '',// productUrl
				're_tasting_club_product': productObject.re_tasting_club_product
			};

			dataLayer.push(obj);
		}
	},
	trackCheckoutStartClick: function (method) {
		var obj = {
			'event': 'beginCheckout',
			'method': method
		};
		dataLayer.push(obj);
	}
};
/**
 * Returns an object which contains product data in cart
 *
 * @returns Object
 */
function getProductsInCart(pid) {
	if ($('input[name=cartData]').length > 0) {
		var cart = JSON.parse($('input[name=cartData]').val());
		var products = cart.product;
		for (var i = 0; i < products.length; i++) {
			if (products[i].product_ID == pid) {
				// object to be pushed
				var obj = {
					'product_brand': products[i].product_brand,
					'product_category': products[i].product_category,
					'product_hierarchy': products[i].product_hierarchy,
					'product_ID': products[i].product_ID,
					'product_name': products[i].product_name,
					'product_price': products[i].product_price,
					'product_price_old': products[i].product_price_old,
					'product_quantity': products[i].product_quantity,
					'product_SKU': products[i].product_SKU,
					'product_stock_status': products[i].product_stock_status,
					'product_variant': products[i].product_variant,
					'product_vat': products[i].product_vat,
					'product_set_capacity': products[i].product_set_capacity,
					'product_set_name':  products[i].product_set_name,
					'product_set_price': products[i].product_set_price,
					'product_set_size': products[i].product_set_size,
					'product_set_SKU': products[i].product_set_size,
					'product_set_type': products[i].product_set_type,
					'voucher_ID': products[i].voucher_ID,
					'voucher_total': products[i].voucher_total
				};
			}
		}
		var productObj = {product: obj};
		return productObj;
	}
}

module.exports = cart
/* jshint ignore:end */
